import { render, staticRenderFns } from "./BindsRipple.vue?vue&type=template&id=6d004900&"
import script from "./BindsRipple.vue?vue&type=script&lang=js&"
export * from "./BindsRipple.vue?vue&type=script&lang=js&"
import style0 from "./BindsRipple.vue?vue&type=style&index=0&id=6d004900&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports